import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Filter = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.65 6a1 1 0 0 1 1-1H19a1 1 0 1 1 0 2H5.65a1 1 0 0 1-1-1Zm4.23 5.91a1 1 0 0 1 1-1H19a1 1 0 1 1 0 2H9.88a1 1 0 0 1-1-1ZM13.76 17a1 1 0 1 0 0 2H19a1 1 0 1 0 0-2h-5.24Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Filter
